import { render, staticRenderFns } from "./IntroducerBankAccountName.vue?vue&type=template&id=6b05af39"
import script from "./IntroducerBankAccountName.vue?vue&type=script&lang=js"
export * from "./IntroducerBankAccountName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports